import styled from '@emotion/styled';
import {EUndecoratedButton} from 'webapp-lib/Components';
import {
  mixinFlexboxRow,
  mixinFlexCenter,
  mixinSVGIcon,
} from 'webapp-lib/styling';

export const PasswordProtectedInfo = styled.p`
  ${mixinFlexboxRow};
  justify-content: flex-start;
  align-items: center;
  gap: var(--gutter-small);
  margin-top: var(--gutter);

  svg {
    ${mixinSVGIcon};
    color: var(--color-notification-important);
  }

  span {
    font-size: var(--font-size-small);
    font-weight: var(--font-weight-thin);
  }
`;

const DOCUMENT_SVG_WIDTH = 180;

export const StyledPdfViewer = styled.div`
  display: flex;
  flex-direction: column;
  padding: var(--gutter-very-tiny);
  margin: var(--gutter-little);

  .pdf-wrapper {
    position: relative;

    > .expand-button {
      position: absolute;
      top: var(--gutter-small);
      right: var(--gutter-small);
      z-index: var(--zindex-elevated);
      padding: var(--gutter-tiny);
      color: var(--color-buttons-primary-active);

      &:hover {
        color: var(--color-buttons-primary-hover);
      }
    }

    > .react-pdf__Document {
      height: 100%;
      width: fit-content;
      margin: 0 auto;

      &.loaded {
        box-shadow: 0 0 4px 0 var(--thumbnail-box-shadow-color);
      }

      &.isExpandable {
        cursor: pointer;
      }

      > .react-pdf__Page {
        // Needed to align loading indicator and to
        // reduce flickering on change between loading indicator and page
        ${mixinFlexCenter}
      }

      > .react-pdf__message {
        height: 100%;
        display: flex;
        justify-content: center;

        svg {
          width: ${DOCUMENT_SVG_WIDTH}px;
        }
      }
    }
  }
`;

export const BottomPageNavigation = styled.div`
  display: flex;
  align-items: center;
  gap: var(--gutter-medium);
  margin: var(--gutter-small) auto 0;

  .page-number {
    display: flex;
    align-items: center;
    gap: var(--gutter-little);
    text-align: center;
    margin-top: var(--gutter-little);
    font-weight: var(--item-read-font-weight);
    font-size: var(--font-size-default);

    .ETextInput {
      width: 60px;
      input {
        padding: var(--gutter-tiny);
        text-align: right;
      }
    }
  }
`;

export const NavigationButton = styled(EUndecoratedButton)`
  display: flex;
  width: fit-content;
  height: fit-content;
  padding: var(--gutter-little);
  color: var(--color-buttons-primary-active);
  border-radius: 50%;

  &:not(:disabled):hover {
    background-color: var(--color-buttons-primary-hover);
    color: var(--color-core-white);
  }

  > svg {
    ${mixinSVGIcon}
  }

  &.prev-button,
  &.next-button {
    position: absolute;
    z-index: var(--zindex-elevated);

    // Center vertically
    top: 0;
    bottom: 0;
    margin: auto;
  }

  &.next-button {
    right: 0;
    margin-right: var(--gutter-tiny);
  }

  &.prev-button {
    left: 0;
    margin-left: var(--gutter-tiny);
  }
`;

const PDF_HIGHLIGHTS_COLUMN_WIDTH = 200;

export const StyledPdfHighlightsColumn = styled.div`
  overflow-y: auto;
  height: 100%;
  width: ${PDF_HIGHLIGHTS_COLUMN_WIDTH}px;
  min-width: ${PDF_HIGHLIGHTS_COLUMN_WIDTH}px;
  max-width: ${PDF_HIGHLIGHTS_COLUMN_WIDTH}px;
`;

export const StyledPdfViewerColumn = styled.div`
  width: 100%;
`;

export const PdfHighlightsWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
`;
